/**
 * Agent Persona definitions
 *
 * Personas tailor the AI's behavior, system prompt, and skill set.
 * Global personas are platform-defined. Workspace personas (future)
 * can override or extend these.
 *
 * Icons are lucide-react icon names (rendered by the UI layer).
 */

export interface PersonaDef {
  id: string
  name: string
  /** Lucide icon name */
  icon: 'BarChart3' | 'ClipboardList' | 'Calculator' | 'Search' | 'Sparkles'
  tagline: string
  version: string
}

export const PERSONAS: PersonaDef[] = [
  { id: 'data-analyst', name: 'Data Analyst', icon: 'BarChart3', tagline: 'Analyze, transform, and visualize your spreadsheets and databases', version: 'v1.0' },
  { id: 'super-clerk', name: 'Super Clerk', icon: 'ClipboardList', tagline: 'Organize, format, and batch-process your files and documents', version: 'v1.0' },
  { id: 'accountant', name: 'Accountant', icon: 'Calculator', tagline: 'Reconcile, calculate, and generate financial reports from your data', version: 'v1.0' },
  { id: 'research-assistant', name: 'Research Assistant', icon: 'Search', tagline: 'Search the web, summarize, and extract insights across your files', version: 'v1.0' },
]

export const DEFAULT_PERSONA_ID = 'data-analyst'

export function getPersona(id: string): PersonaDef | undefined {
  return PERSONAS.find(p => p.id === id)
}
